import { useCallback } from 'react';
import shortid from 'shortid';
import { FS } from '../constants';
import { Doc, generateToDocFn } from '../types/Document';
import { IEventRsvp } from '../types/Event';
import {
  CollectionListener,
  createCollectionListenerStore,
  useCollectionListener
} from './collectionListener';
import { setDoc, store, useMappedLoadingValue } from './db';
import { now } from './time';

const collection = () => store().collection(FS.eventRsvps);
export const toEventRsvpDoc = generateToDocFn<IEventRsvp>();

export const rsvpForEvent = (eventId: string, userId: string) => {
  const doc: Doc<IEventRsvp> = {
    id: shortid(),
    collection: FS.eventRsvps,
    data: {
      eventId,
      userId,
      createdAt: now(),
      attended: false
    }
  };
  return setDoc(doc);
};

export const unRsvpForEvent = (rsvpId: string) => {
  return collection().doc(rsvpId).delete();
};

const rsvpsByUserStore = createCollectionListenerStore(
  (userId) =>
    new CollectionListener(
      collection().where('userId', '==', userId),
      toEventRsvpDoc
    )
);

export const useRsvpsForUser = (userId: string) => {
  return useCollectionListener(rsvpsByUserStore(userId));
};

export const useRsvpForEvent = (eventId: string, userId: string) => {
  const findRsvp = useCallback(
    (rsvps: Doc<IEventRsvp>[]) =>
      rsvps.find((r) => r.data.eventId === eventId) || null,
    [eventId]
  );
  return useMappedLoadingValue(useRsvpsForUser(userId), findRsvp, true);
};

const recentRsvpsForEventStore = createCollectionListenerStore(
  (eventId) =>
    new CollectionListener(
      collection()
        .where('eventId', '==', eventId)
        .orderBy('createdAt', 'desc')
        .limit(10),
      toEventRsvpDoc
    )
);

export const useRecentRsvpsForEvent = (eventId: string) => {
  return useCollectionListener(recentRsvpsForEventStore(eventId));
};

const rsvpsForEventStore = createCollectionListenerStore(
  (eventId) =>
    new CollectionListener(
      collection().where('eventId', '==', eventId).orderBy('createdAt', 'desc'),
      toEventRsvpDoc
    )
);

export const useRsvpsForEvent = (eventId: string) => {
  return useCollectionListener(rsvpsForEventStore(eventId));
};
